import React, { useState } from "react";

import { Button, Form, Input, Segment } from 'semantic-ui-react'

import VanuLogo from '../images/vanu-purple.png';
import vanu from '../apis/vanu';


const Login = ({ logged, onLogin }) => {

    const [useRegistration, setUseRegistrationForm] = useState(false);

    const doLogin = async (username, password) => {
        try {
            const response = await vanu.post('/api-token-auth/', {
                username: username,
                password: password
            })
            const token = response.data.token;
            document.cookie = `vanu_token=${token}; path=/; max-age=604800`;
            document.cookie = `vanu_user=${username}; path=/; max-age=604800`;
            onLogin(token, username);
        } catch (error) {
            alert('Please insert valid credentials!');
        }
    }

    const handleSubmitLogin = (e) => {
        e.preventDefault();

        const username = e.target.elements.username_login.value;
        const password = e.target.elements.password_login.value;

        doLogin(username, password);

    }

    const handleSubmitRegister = async (e) => {
        e.preventDefault();

        const username = e.target.elements.username.value;
        const email = e.target.elements.email.value;
        const password1 = e.target.elements.password1.value;
        const password2 = e.target.elements.password2.value;

        if (password1 !== password2) {
            alert('Make sure both password fields are the same!');
            return;
        }

        try {
            await vanu.post('/create-user/', {
                username: username,
                email: email,
                password: password1
            })
            doLogin(username, password1);

        } catch (err) {
            alert('An error occurred');
        }

    }

    if (!logged) {
        return <div></div>
    }

    if (useRegistration) {
        return (
            <div className='ui middle aligned center aligned grid'>
                <div className="row">
                    <div className="column">
                        <h2 className="ui image header">
                            <img src={VanuLogo} className="image" alt='Register your account' />
                            <div className="content">
                                Create your account
                    </div>
                        </h2>
                        <p>Password must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.</p>
                        <Form
                            className="ui large form"
                            onSubmit={handleSubmitRegister}
                        >
                            <Segment stacked>
                                <Form.Field>
                                    <label>Username</label>
                                    <Input id='username' icon='user' iconPosition='left' placeholder='Username' required />
                                </Form.Field>
                                <Form.Field>
                                    <label>Email</label>
                                    <Input id='email' icon='mail' iconPosition='left' placeholder='Email' type='email' required />
                                </Form.Field>
                                <Form.Field>
                                    <label>Password</label>
                                    <Input id='password1' icon='lock' iconPosition='left' placeholder='Password' type='password' required 
                                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" />
                                </Form.Field>
                                <Form.Field>
                                    <label>Confirm Password</label>
                                    <Input id='password2' icon='lock' iconPosition='left' placeholder='Password' type='password' required 
                                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" />
                                </Form.Field>
                                <Button
                                    id='btn-signup'
                                    type='submit'
                                    className='ui fluid large blue submit button'
                                >Sign Up
                    </Button>
                            </Segment>
                        </Form>

                        <div className="ui message">
                        <p>Have already an account?</p>
                        <div>
                            <Button
                                id='btn-signin'
                                type='submit'
                                className='ui fluid large blue submit button'
                                onClick={() => setUseRegistrationForm(false)}
                            >Sign in
                            </Button>
                        </div>
                    </div>

                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='ui middle aligned center aligned grid'>
            <div className="row">
                <div className="column">
                    <h2 className="ui image header">
                        <img src={VanuLogo} className="image" alt='Login from the app' />
                        <div className="content">
                            Log-in to your account
                    </div>
                    </h2>
                    <Form
                        className="ui large form"
                        onSubmit={handleSubmitLogin}
                    >
                        <Segment stacked>
                            <Form.Field>
                                <label>Username</label>
                                <Input id='username_login' icon='user' iconPosition='left' placeholder='Username' />
                            </Form.Field>
                            <Form.Field>
                                <label>Password</label>
                                <Input id='password_login' icon='lock' iconPosition='left' placeholder='Password' type='password' />
                            </Form.Field>
                            <Button
                                id='btn-login'
                                type='submit'
                                className='ui fluid large blue submit button'
                            >Login
                    </Button>
                        </Segment>
                    </Form>

                    <div className="ui message">
                        <p>New to us?</p>
                        <div>
                            <Button
                                id='btn-open-signup'
                                type='submit'
                                className='ui fluid large blue submit button'
                                onClick={() => setUseRegistrationForm(true)}
                            >Sign up
                            </Button>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default Login;